import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'src/app/page/masterdata/dummy-routes/dummy-routes.component';

@Component({
    selector: 'app-add-dummy-route',
    templateUrl: './add-dummy-route.component.html',
    styleUrls: ['./add-dummy-route.component.scss'],
    standalone: false // NOSONAR
})
export class AddDummyRouteComponent implements OnInit {
	pageName;
	dummyRoute;
	error;
	enableError: boolean = false;
	action;
	heading;

	constructor(public dialogRef: MatDialogRef<AddDummyRouteComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {
		console.info("data store", dataStore);
		this.pageName = dataStore.page;

		if (this.dataStore.performAction == 'AddCell') { // NOSONAR
			this.action = 'AddCell';
			this.heading = "Add";
		}
	}

	ngOnInit(): void { // NOSONAR 

	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	close(): void {
		this.dialogRef.close();
	}

	public saveClick() {
		if (this.dummyRoute == '' || this.dummyRoute == null || this.dummyRoute == undefined || this.dummyRoute.trim().length == 0) { // NOSONAR
			this.error = "error";
			this.enableError = true;
		}
		else {
			this.dialogRef.close({ event: this.action, data: this.dummyRoute });
		}
	}

}
